import React from 'react';

import messages from './messages';
import { useFulfillmentPlanIdContext } from '../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useSalesOrderIdContext } from '../../../../context/sales-order-id-context-provider';
import OrderTemplatesContainer from '../../../../modals/order-details-modal/order-details-modal-content/order-templates/order-templates-container';
import ExpanderSection from '../../../tab-section/expander-section/expander-section';
import SectionTitle from '../../../tab-section/title';
import { OrderDetailsSectionId } from '../../order-details-expanded-section-provider';

import style from './customer-communication.module.less';
import textStyle from 'ui-components/components/text/text.module.less';

const CustomerCommunication = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const salesOrderId = useSalesOrderIdContext();

  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.sectionAriaLabel}
      contentClassName={style['customer-communication-section-content']}
      headerContent={<SectionTitle messageDescriptor={messages.templatesSectionTitle} />}
      sectionContent={
        <OrderTemplatesContainer
          className={style['od-canvas-customer-communication']}
          fulfillmentPlanId={fulfillmentPlanId}
          isActive
          labelClassName={textStyle.label}
          salesOrderId={salesOrderId}
          valueClassName={textStyle.paragraph}
        />
      }
      sectionId={OrderDetailsSectionId.CustomerCommunication}
    />
  );
};

export default CustomerCommunication;
